import React, { useState, useEffect } from 'react';
import { qrCodeService, templateService } from '../services/api';
import './QRCodeModal.css';

function QRCodeModal({ qrCode, onClose, onSave }) {
  const [id, setId] = useState(qrCode?.id || '');
  const [nome, setNome] = useState(qrCode?.nome || '');
  const [urlDestino, setUrlDestino] = useState(qrCode?.urlDestino || '');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  useEffect(() => {
    loadTemplates();
  }, []);

  const loadTemplates = async () => {
    try {
      const data = await templateService.list();
      setTemplates(data);
    } catch (err) {
      console.error('Erro ao carregar templates:', err);
      setTemplates([]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!urlDestino) {
      setError('URL de destino é obrigatória');
      return;
    }

    try {
      setLoading(true);

      const data = {
        nome,
        urlDestino,
        customizacao: selectedTemplate ? selectedTemplate.customizacao : null
      };

      if (qrCode) {
        await qrCodeService.update({ ...data, id: qrCode.id });
        onSave('QR Code atualizado com sucesso!');
      } else {
        // Adicionar ID customizado se fornecido
        if (id.trim()) {
          data.id = id.trim();
        }
        await qrCodeService.create(data);
        onSave('QR Code criado com sucesso!');
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Erro ao salvar QR Code');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h2>{qrCode ? 'Editar QR Code' : 'Novo QR Code'}</h2>

        <form onSubmit={handleSubmit}>
          {!qrCode && (
            <div className="form-group">
              <label htmlFor="id">ID Personalizado (opcional)</label>
              <input
                type="text"
                id="id"
                value={id}
                onChange={(e) => setId(e.target.value)}
                placeholder="Ex: promo-verao ou produto123"
                disabled={loading}
                pattern="[a-zA-Z0-9_\-]*"
                title="Use apenas letras, números, hífens (-) e underscores (_)"
              />
              <small style={{ color: '#666', fontSize: '0.85rem', marginTop: '0.25rem', display: 'block' }}>
                Deixe vazio para gerar automaticamente. Esse será o link: /prod/{id || '{id-gerado}'}
              </small>
            </div>
          )}

          <div className="form-group">
            <label htmlFor="nome">Nome (opcional)</label>
            <input
              type="text"
              id="nome"
              value={nome}
              onChange={(e) => setNome(e.target.value)}
              placeholder="Ex: Promoção de Verão"
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="urlDestino">URL de Destino *</label>
            <input
              type="url"
              id="urlDestino"
              value={urlDestino}
              onChange={(e) => setUrlDestino(e.target.value)}
              placeholder="https://exemplo.com"
              required
              disabled={loading}
            />
          </div>

          {!qrCode && templates.length > 0 && (
            <div className="form-group">
              <label htmlFor="template">Aplicar Template de Personalização (opcional)</label>
              <select
                id="template"
                value={selectedTemplate?.id || ''}
                onChange={(e) => {
                  const template = templates.find(t => t.id === e.target.value);
                  setSelectedTemplate(template || null);
                }}
                disabled={loading}
              >
                <option value="">Sem personalização</option>
                {templates.map(template => (
                  <option key={template.id} value={template.id}>
                    {template.nome}
                  </option>
                ))}
              </select>
              <small style={{ color: '#666', fontSize: '0.85rem', marginTop: '0.25rem', display: 'block' }}>
                Você pode personalizar ainda mais após criar o QR Code
              </small>
            </div>
          )}

          {error && <div className="error">{error}</div>}

          <div className="modal-actions">
            <button type="button" className="btn btn-secondary" onClick={onClose} disabled={loading}>
              Cancelar
            </button>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Salvando...' : 'Salvar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default QRCodeModal;